import { createUseStyles } from 'react-jss'
import { colors } from '#base/js/variables.style'

export const styles = {
  configRow: {
    padding: '10px 0',
    composes: 'flex-row',
    alignItems: 'center',
    columnGap: '1%'
  },
  configRowLeft: {
    extend: 'configRow',
    justifyContent: 'left'
  },
  configRowRight: {
    extend: 'configRow',
    justifyContent: 'right'
  },
  filename: {
    flex: 6,
    '& .form-element, & .form-element-border': {
      borderRadius: '4px'
    },
    '@media (max-width: 992px)': {
      flex: 2
    }
  },
  filetype: {
    flex: 1
  },
  contentContainer: {
    margin: '20px 0',
    border: `1px solid ${colors.borderGray}`,
    borderRadius: '4px',
    overflow: 'auto'
  },
  content: {
    padding: '20px',
    background: colors.backgroundGray
  },
  filterContainer: {
    composes: 'flex-row',
    flexWrap: 'wrap',
    rowGap: '10px',
    padding: '10px',
    borderBottom: `1px solid ${colors.borderGray}`
  },
  chartContainer: {
    pointerEvents: 'none'
  },
  actions: {
    display: 'flex',
    padding: '10px',
    alignItems: 'center',
    justifyContent: 'right'
  }
}

export const useStyles = createUseStyles(styles)
